export default __webpack_public_path__ + "static/media/ja.e2f58c0d.svg";